// extracted by mini-css-extract-plugin
export default {"copy":"mfBy9","promoCode":"pbT90","isCopied":"rlohN"};